import React, { useRef } from 'react'
import SearchFloatingPanel, { SearchFloatingPanelProps } from 'components/SearchV2/Components/Mobile/SearchFloatingPanel/SearchFloatingPanel'
import styled from 'styled-components'
import { rem } from 'polished'
import LocationSearchField from '../LocationSearchField/LocationSearchField'
import useLocationSearchFieldProps from 'components/SearchV2/Hooks/useLocationSearchFieldProps'
import { TypeAheadSearchTypes } from 'api/search'
import { LOCATION_SEARCH_INPUT_PLACEHOLDER_LABEL } from 'constants/search'

const ContentContainer = styled.div`
  display: flex;
  padding: ${rem(20)};
`

interface Props extends
  Omit<
    SearchFloatingPanelProps,
    'title' | 'confirmText' | 'isConfirmButtonHidden' | 'children'
  >
{
  searchTypes?: Array<App.SearchType>;
  typeaheadTypes?: Array<TypeAheadSearchTypes>;
  placeholder?: string;
  isSecondaryLocation?: boolean;
  title?: string;
  popularPlaces?: Array<App.SearchItem>;
}

function LocationFloatingPanel(props: Props) {
  const {
    onConfirm,
    searchTypes,
    typeaheadTypes,
    placeholder = LOCATION_SEARCH_INPUT_PLACEHOLDER_LABEL,
    isSecondaryLocation,
    title = 'Where are you going?',
    popularPlaces,
  } = props
  const selectRef = useRef(null)

  const locationSearchProps = useLocationSearchFieldProps({
    selectRef,
    searchTypes,
    typeaheadTypes,
    onSelect: onConfirm,
    isSecondaryLocation,
    popularPlaces,
  })

  return (
    <SearchFloatingPanel
      {...props}
      title={title}
      isConfirmButtonHidden
    >
      <ContentContainer>
        <LocationSearchField
          menuIsOpen
          ref={selectRef}
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus={props.isOpen}
          {...locationSearchProps}
          placeholder={placeholder}
        />
      </ContentContainer>
    </SearchFloatingPanel>
  )
}

export default LocationFloatingPanel
